export default __webpack_public_path__ + "static/Virtual-Reality-db067010c7d7749aae8b4c7e8642d934.webp";